import getSymbolFromCurrency from 'currency-symbol-map';

// import A713 from '../assets/promotions/713/chinesehotpot.jpg';
// import B713 from '../assets/promotions/713/sangria.jpg';
// import D713 from '../assets/promotions/713/hotpot_menu.jpg';
import G713 from '../assets/promotions/713/LM_Seafood_Platter.jpg';

import A714 from '../assets/promotions/714/beerbucket.jpg';
import B714 from '../assets/promotions/714/fine-de-claire.jpg';
import C714 from '../assets/promotions/714/lavie.jpg';
import D714 from '../assets/promotions/714/lescoop.jpg';
import E714 from '../assets/promotions/714/Mongolian-BOwl.jpg';
import F714 from '../assets/promotions/714/Leaflet_Le_Scoop.jpg';
import H714 from '../assets/promotions/714/Draught_Beer_Tower.jpg';
import I714 from '../assets/promotions/714/LM_Seafood_Platter.jpg';
import J714 from '../assets/promotions/714/Negroni_cocktail_promotion.jpg';
import K714 from '../assets/promotions/714/sea_to_table.jpg';

import A506 from '../assets/promotions/506/fish-head.jpg';
import B506 from '../assets/promotions/506/sake.jpg';
import C506 from '../assets/promotions/506/sashimi-moriawse.jpg';
import D506 from '../assets/promotions/506/sushi_sashimi.jpg';
import E506 from '../assets/promotions/506/Oyster_Tempura.jpg';

import A505 from '../assets/promotions/505/fine-de-claire.jpg';

import Offer1 from '../assets/Ariake_Fish_head.jpg';
import Offer2 from '../assets/Ariake_Sake_Flight.jpg';
import Offer3 from '../assets/Ariake_Sushi_Sashimi.jpg';

import defaultLogo from '../assets/default-logo.png';

export const printCurrencySymbol = (hotelDetails = {}) => {
    let definedSymbol = hotelDetails?.hotel_config?.currency_symbol;
    if (definedSymbol) {
        return definedSymbol;
    }
    const currencyCode = hotelDetails.country?.currency_code?.toUpperCase();
    if (
        currencyCode === 'AED' ||
        currencyCode === 'FJD' ||
        currencyCode === 'PHL' ||
        currencyCode === 'SAR' ||
        currencyCode === 'OMR'
    ) {
        return currencyCode;
    }
    return getSymbolFromCurrency(currencyCode);
};

export const getBanner = (id) => {
    let banner = [];
    switch (id) {
        case '713':
            banner = [G713];
            break;

        case '714':
            banner = [B714, C714, F714, H714, I714, J714, K714];
            break;

        case '506':
            banner = [E506];
            break;

        case '505':
            banner = [A505];
            break;

        default:
            banner = [Offer1, Offer2, Offer3];
            break;
    }
    return banner;
};
